<template>
  <div class='search-results-page'>
    <page-header
      :title="
        this.$route.params.action === 'search'
          ? 'Search results'
          : this.$route.params.terms
      "
      :back="true"
    />
    <span v-if="hasInvoiceAccess">
      <div class="container" v-if="this.$route.params.action === 'search'">
        <!-- Customers -->
        <h4 class="p-0 m-0 mt-20 strong">Customers</h4>
        <p class="m-0 p-0 mt-5 em" v-if="filteredCustomerList.length > 0">
          Click to create invoice for user
        </p>
        <h3 class="center p-15" v-if="filteredCustomerList.length < 1">
          No customer results to display
        </h3>
      </div>
      <ul class="l-reset cust-list">
        <li
          class="p-20"
          v-for="(x, index) in filteredCustomerList"
          :key="index"
          @click="() => handleCustomerClick(x)"
        >
          <customer-result-node :data="x" />
        </li>
      </ul>
      <!-- Invoice -->
      <collapsible-content title="Invoices">
        <span>
          <h3
            class="center p-15"
            v-if="loadedResults && invoiceList.length < 1"
          >
            No invoices to display
          </h3>
          <Invoice
            v-for="invoice in invoiceList"
            :key="invoice.invoiceNumber"
            :info="invoice"
            width='100%'
          />
          <h3 class="center p-15" v-if="loadingSearch">Loading results...</h3>
          <div
            class="center p-15"
            v-if="loadedResults && loadedResults.total > invoiceList.length"
          >
            <button
              class="green p-10"
              @click="loadMoreInvoices"
              :disabled="loadingSearch"
            >
              Load more
            </button>
          </div>
        </span>
      </collapsible-content>
    </span>

    <!-- Images -->
    <collapsible-content title="Images" v-if="hasImagesAcces && !isFilter">
      <gallery-image-list
        :images="searchData['images']"
        :onClickImage="(img) => goToLink(`/site/images/${img.category || 'all'}`)"
      />
    </collapsible-content>
    <!-- Objects -->
    <collapsible-content title="Objects" v-if="hasObjectAccess && !isFilter">
      <div class="row pb-20">
        <div
          v-for="(obj, i) in searchData['objects']"
          class="card hover mr-10"
          :key="i"
          @click="() => goToLink(`/site/objectmanager/${obj.id}`)"
        >
          <span class="card-title">{{ obj.title }}</span>
          <span class="card-content">
            {{ obj.category || 'No category' }}
          </span>
        </div>
      </div>
    </collapsible-content>
  </div>
</template>

<script>
import Invoice from "../../components/Invoice";
import { filterObjectValues } from "../../utils/filter";
import CustomerResultNode from "../../components/CustomerResultNode";
import GalleryImageList from "../../components/GalleryImageList";
import router from "../index";
import PageHeader from "../../components/PageHeader.vue";
import CollapsibleContent from "@/myComponents/CollapsibleContent.vue";
export default {
  name: "search-route",
  components: {
    Invoice,
    CustomerResultNode,
    PageHeader,
    GalleryImageList,
    CollapsibleContent,
  },
  data: function () {
    return {
      loadingSearch: false,
      collasped: [],
    };
  },
  mounted: async function () {
    if (!this.$store.getters.customerList.loaded) {
      this.$store.dispatch("loadCustomerList");
    }
    const searchPayload = {
      action: this.$route.params.action,
      terms: encodeURIComponent(
        this.searchTerms.replace(/\//g, "").replace(/\./, "").replace(/#/g, "")
      ),
      page: 1,
    };
    await this.$store.dispatch("globalSearch", searchPayload);
    if (!this.loadedResults) {
      this.loadingSearch = true;
      await this.$store.dispatch("loadSearchResults", searchPayload);
      this.loadingSearch = false;
    }
  },
  methods: {
    goToLink (path) {
      router.push({ path })
    },
    toggleCollapsed(id) {
      if (this.collasped.includes(id)) {
        this.collasped = this.collasped.filter((i) => i !== id);
      } else {
        this.collasped.push(id);
      }
    },
    handleCustomerClick(cust) {
      router.push("/newinvoice/create/" + cust.reference);
    },
    async loadMoreInvoices() {
      this.loadingSearch = true;
      const searchPayload = {
        action: this.$route.params.action,
        terms: encodeURIComponent(
          this.searchTerms
            .replace(/\//g, "")
            .replace(/\./, "")
            .replace(/#/g, "")
        ),
        page: this.loadedResults.page + 1,
      };
      await this.$store.dispatch("loadSearchResults", searchPayload);
      this.loadingSearch = false;
    },
  },
  computed: {
    isFilter () {
      return this.$route.path.includes('/search/filter/')
    },
    searchTerms() {
      return this.$route.params.terms;
    },
    loadedResults() {
      const searchResults = this.$store.getters.searchResults;
      return searchResults[encodeURIComponent(this.searchTerms)]
    },
    invoiceList() {
      return (this.loadedResults && this.loadedResults.results) || [];
    },
    filteredCustomerList() {
      let list = [...this.$store.getters.customerList.data];
      list.reverse();
      return filterObjectValues(list, this.searchTerms, null);
    },
    searchData() {
      return this.$store.getters.searchData;
    },
    hasInvoiceAccess() {
      return this.$store.getters.hasInvoiceAccess;
    },
    hasObjectAccess() {
      const module =
        this.modules &&
        this.modules.Website &&
        this.modules.Website.find((m) => m.name === "Object manager");
      return module && module.active;
    },
    hasImagesAcces() {
      const module =
        this.modules &&
        this.modules.Website &&
        this.modules.Website.find((m) => m.name === "Edit images");
      return module && module.active;
    },
    modules() {
      return this.$store.getters.moduleManager.data;
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.search-results-page {
  .new-invoice-dash {
    width: 155px;
    margin-top: 18px;
  }
  .my-components--icon-card {
    width: 100%;
  }
  .cust-list {
    width: 96%;
    margin: 0 auto;
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    li {
      cursor: pointer;
      width: calc(50% - 40px);
      background-color: #fff;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
      margin-bottom: 30px;
      padding: 10px;
      border-radius: 10px;
      &:hover {
        box-shadow: 0 0 0 1px $lightBlue;
      }
      @media screen and (max-width: 700px) {
        width: calc(97% - 40px);
        margin: 0 auto 20px auto;
      }
    }
  }
}
</style>
